import axios from 'axios';

const apiClient = axios.create({
  withCredentials: true,
  baseURL: '/', // This ensures relative URLs are properly handled
});

// Global security configuration
// This approach is safer than adding allowAbsoluteUrls: false to each request
apiClient.interceptors.request.use((config) => {
  // Ensure the URL is relative ( security measure similar to allowAbsoluteUrls: false )
  if (config.url && config.url.startsWith('http')) {
    throw new Error('Absolute URLs are not allowed for security reasons');
  }

  return config;
});

// Export the axios CancelToken for components that need it
export const { CancelToken } = axios;
export const { isCancel } = axios;

export default apiClient;
